<template>
	<div id="widgetRegion" class="h-100" :style="`width:100%`">
		<div :style="`width:fit-content;margin-left:auto;margin-right:auto;`">
			<grid-layout
				ref="refGridLayout"
				:layout.sync="layout_"
				:cols="cols"
				:colNum="colNum"
				:row-height="blockSize"
				:is-draggable="true"
				:is-resizable="true"
				:responsive="false"
				:vertical-compact="true"
				:prevent-collison="true"
				:style="`width:${gridWidth}px;`"
				:margin="[gap, gap]"
				@layout-updated="layoutUpdated"
			>
				<widget-item-template
					v-for="item in layout_"
					:key="item.i"
					:params="{ ...item }"
					:component="getComponent(item.widgetTitle)"
					v-on:delete="onClickDelete"
					:debouncedUpdate="debouncedUpdate"
				/>
			</grid-layout>
		</div>
	</div>
</template>

<script>
import { GridLayout } from 'vue-grid-layout';
import WidgetItemTemplate from './WidgetItemTemplate.vue';
import { serviceMethods, serviceComputed } from '@common/Widget/store/helpers';
import { rootComputed } from '@/store/common/helpers';
import _ from 'lodash';
export default {
	components: {
		GridLayout,
		WidgetItemTemplate
	},
	mounted() {
		this.$sf_toggleLoading(true);
		this.selectWidgetMaster_(this.getMessage_)
			.then(list => {
				this.loadComponents_(list);
				return this.selectUserWidgetList();
			})
			.finally(() => this.$sf_toggleLoading(false));

		const observer = new ResizeObserver(this.setGridWidth);
		observer.observe(this.$el);
		this.setRefGridLayout(this.$refs.refGridLayout);
	},
	data() {
		const gap = 15;
		const blockSize = 300;
		const colNum = 8;
		const cols = { lg: 8, md: 6, sm: 4, xs: 2, xxs: 1 };

		const breakpoints = Object.entries(cols).reduce(
			(map, [colName, col]) => Object.assign(map, { [colName]: col * blockSize + (col - 1) * gap }),
			{}
		);

		return {
			colNum,
			gap,
			cols,
			breakpoints,
			blockSize,
			gridWidth: 2400
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		debouncedUpdate() {
			return _.debounce(this.updateWidgetItems_, 1000, { leading: false, trailing: true });
		}
	},
	methods: {
		...serviceMethods,
		layoutUpdated(newLayout) {
			// console.log('layoutUpdated', newLayout);
			if (newLayout.findIndex(r => r.dragging) === -1) {
				this.debouncedUpdate(newLayout);
			}
		},
		getComponent(widgetTitle) {
			const widget = this.getWidget_(widgetTitle);
			return widget ? widget.component : () => {};
		},
		setGridWidth(e) {
			const { width: containerWidth } = e[0].contentRect;
			const nColumns = Math.floor((containerWidth - this.gap) / (this.blockSize + this.gap));
			let gridWidth = nColumns * this.blockSize + (nColumns + 1) * this.gap;
			const MAX_WIDTH = this.blockSize * 8 + this.gap * 9;
			const MIN_WIDTH = this.blockSize * 1 + this.gap * 2;
			gridWidth = Math.min(Math.max(gridWidth, MIN_WIDTH), MAX_WIDTH);
			this.gridWidth = gridWidth;
			this.colNum = nColumns;
			// console.log('setGridWidth', containerWidth, gridWidth, nColumns);
		},
		onClickDelete(deleteItem) {
			this.$store.commit('widgetStore/DELETE', deleteItem);
		},
		selectUserWidgetList() {
			this.selectUserWidgetList_();
		}
	}
};
</script>
